/* eslint-disable camelcase */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import SiteLoader from '../layout/site-loader';
import {getRepHomePage} from '../../actions/home';
import PageTitle from '../common/page-title/index';
import Tile from '../common/home/tile';
import HomePageCarousel from '../common/home/home-page-carousel';
import './styles.css';

class HomePage extends Component {
  state = {
    height: 0,
    tileHeight: 0
  };

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getRepHomePage());
    this.calculateHeights();
    window.addEventListener('resize', this.calculateHeights.bind(this));
  }

  calculateHeights() {
    const width = window.innerWidth;
    if (width >= 768) {
      const height = window.innerHeight;
      const tileHeight = height / 3;
      this.setState({
        height,
        tileHeight
      });
    } else {
      const height = window.innerHeight;
      const tileHeight = width / 2;
      this.setState({
        height,
        tileHeight
      });
    }
  }

  render() {
    const {height, tileHeight} = this.state;
    const {
      profileLoaded, tiles, carousels, loading, carouselSpeed, profile
    } = this.props;

    if (!profileLoaded || loading) {
      return <SiteLoader/>;
    }

    const carouselInstance = (
      <HomePageCarousel carousels={carousels} carouselSpeed={carouselSpeed} height={height}/>
    );

    const tileInstances = (tiles || []).map((tile, key) => {
      const width = tile.reference === 'tile_5' ? 'col-xs-12' : 'col-xs-6';
      return (
        <Tile className={width} index={key} key={key} profile={profile} tile={tile} tileHeight={tileHeight}/>
      );
    });

    return (
      <div className="tiles-container">

        <PageTitle pageTitle='Home'/>

        {profileLoaded && (
          <div className="home-slide">
            <div className="row">
              <div className="col-md-6">
                <div className="tile-carousel" style={{height}}>
                  {carouselInstance}
                </div>
              </div>
              <div className="col-md-6">
                {tileInstances}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.viewConfig.profile,
  profileLoaded: state.viewConfig.loaded,
  carousels: state.repHome.home_carousels,
  tiles: state.repHome.home_tiles,
  loading: state.repHome.fetching && !state.repHome.fetched,
  carouselSpeed: state.repHome.carousel_speed,
  unreadMessages: state.messages.unreadMessagesCount,
});

export default connect(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/rep-home/home-page.jsx